export default __webpack_public_path__ + "static/media/BatteryIcon.50da6019.png";